export default __webpack_public_path__ + "static/media/LandingImage.a851b03c.jpeg";